// 2trendy — assets/wishlist.js (Engelsk/COM) - FORCE_SHOP='en' - skriver Top 20 til lb:en

(function () {
  var STORAGE_KEY = 'tt_wishlist';

  // ── KONFIG ────────────────────────────────────────────────────────────
  var FORCE_SHOP = 'en';

  var SHOP_KEYS = {
    dk:'70595a', no:'c41667', se:'941362', nl:'9166e3', de:'eb1856',
    en:'c4cb3d', pl:'e32913', fr:'2fadbc', be:'7cd6af', at:'1d3332'
  };

  function detectShop() {
    if (FORCE_SHOP) return FORCE_SHOP;
    var h = window.location.hostname.toLowerCase();
    if (h.indexOf('myshopify.com') > -1) return null;
    var map = { '.dk':'dk', '.no':'no', '.se':'se', '.nl':'nl', '.de':'de',
                '.pl':'pl', '.fr':'fr', '.be':'be', '.at':'at', '.com':'en' };
    for (var tld in map) { if (h.slice(-tld.length) === tld) return map[tld]; }
    return null;
  }

  var SHOP = detectShop();
  var SHOP_ID = SHOP ? SHOP_KEYS[SHOP] : null;
  function K(metric) { return SHOP_ID ? ('2trendy_' + SHOP + '_wl_' + metric + '_' + SHOP_ID) : null; }

  var STAT_API = 'https://countapi.mileshilliard.com/api/v1';
  var STAT_KEYS = {
    wishlist_like:        K('likes'),
    wishlist_add_to_cart: K('cart'),
    wishlist_open_shared: K('opened'),
    wishlist_share:       K('share'),
    wishlist_visit:       K('visits'),
    wishlist_uvisit:      K('uvisits')
  };
  var GEN_KEY = K('gen');

  // ── Top-10 (Upstash sorted set) ──
  var TOP_URL   = 'https://well-shrew-128565.upstash.io';
  var TOP_TOKEN = 'gQAAAAAAAfY1AAIgcDIyYTJjN2U4NDY5ZDM0ODhjYmRiY2Q0NDljYjAwMzQxMQ';
  var DEBUG_TOP20 = false;
  function bumpTopProduct(handle) {
    if (!SHOP || !handle) {
      if (DEBUG_TOP20) {
        console.warn('Top 20 ikke registreret - mangler SHOP eller handle:', {
          shop: SHOP,
          handle: handle,
          hostname: window.location.hostname
        });
      }
      return;
    }

    fetch(TOP_URL + '/zincrby/lb:' + SHOP + '/1/' + encodeURIComponent(handle) + '?_token=' + encodeURIComponent(TOP_TOKEN), {
      method: 'GET',
      cache: 'no-store',
      keepalive: true
    })
    .then(function(r) {
      if (!DEBUG_TOP20) return;
      return r.json().then(function(d) {
        console.log('Top 20 registreret:', {
          status: r.status,
          shop: SHOP,
          board: 'lb:' + SHOP,
          handle: handle,
          response: d
        });
      });
    })
    .catch(function(err) {
      if (DEBUG_TOP20) console.error('Top 20 Upstash fejl:', err);
    });
  }

  // ── Oversættelser (sprog vælges automatisk ud fra shop) ──
  var TR = {
    dk: { heading:"Min ønskeliste", sharedFrom:"Ønskeliste fra ", sharedNoName:"Delt ønskeliste", sharedNotice:"Du ser en delt ønskeliste.", clear:"Tøm ønskeliste", share:"Del ønskeliste", empty:"Du har ingen gemte favoritter endnu.", add:"Tilføj til ønskeliste", remove:"Fjern fra ønskeliste", adding:"Tilføjer...", added:"Tilføjet!", addToCart:"LÆG I KURV", tryAgain:"Prøv igen", soldOut:"Udsolgt", chooseVariant:"Vælg variant", chooseSize:"Vælg størrelse", soldOutSuffix:" - Udsolgt", shareTitle:"Del din ønskeliste", shareIntro:"Skriv dit navn, så modtageren ved hvem listen er fra.", shareTip:"Tip: Vil du dele med valgte størrelser? Tryk Gå tilbage og vælg størrelser på dine produkter først — så ved modtageren præcis hvad du ønsker dig.", nameLabel:"Dit navn", namePlaceholder:"f.eks. Frederik", copyLink:"Kopiér link", goBack:"Gå tilbage", copied:"Kopieret!", emptyAlert:"Din ønskeliste er tom — tilføj produkter først.", confirmClear:"Er du sikker på, at du vil tømme din ønskeliste?", anon:"anonym" },
    no: { heading:"Min ønskeliste", sharedFrom:"Ønskeliste fra ", sharedNoName:"Delt ønskeliste", sharedNotice:"Du ser en delt ønskeliste.", clear:"Tøm ønskeliste", share:"Del ønskeliste", empty:"Du har ingen lagrede favoritter ennå.", add:"Legg til i ønskeliste", remove:"Fjern fra ønskeliste", adding:"Legger til...", added:"Lagt til!", addToCart:"LEGG I KURV", tryAgain:"Prøv igjen", soldOut:"Utsolgt", chooseVariant:"Velg variant", chooseSize:"Velg størrelse", soldOutSuffix:" - Utsolgt", shareTitle:"Del ønskelisten din", shareIntro:"Skriv navnet ditt, så mottakeren vet hvem listen er fra.", shareTip:"Tips: Vil du dele med valgte størrelser? Trykk Gå tilbake og velg størrelser på produktene først — så vet mottakeren nøyaktig hva du ønsker deg.", nameLabel:"Navnet ditt", namePlaceholder:"f.eks. Frederik", copyLink:"Kopier lenke", goBack:"Gå tilbake", copied:"Kopiert!", emptyAlert:"Ønskelisten din er tom — legg til produkter først.", confirmClear:"Er du sikker på at du vil tømme ønskelisten din?", anon:"anonym" },
    se: { heading:"Min önskelista", sharedFrom:"Önskelista från ", sharedNoName:"Delad önskelista", sharedNotice:"Du tittar på en delad önskelista.", clear:"Töm önskelista", share:"Dela önskelista", empty:"Du har inga sparade favoriter än.", add:"Lägg till i önskelista", remove:"Ta bort från önskelista", adding:"Lägger till...", added:"Tillagd!", addToCart:"LÄGG I VARUKORG", tryAgain:"Försök igen", soldOut:"Slutsåld", chooseVariant:"Välj variant", chooseSize:"Välj storlek", soldOutSuffix:" - Slutsåld", shareTitle:"Dela din önskelista", shareIntro:"Skriv ditt namn så vet mottagaren vem listan är från.", shareTip:"Tips: Vill du dela med valda storlekar? Tryck Gå tillbaka och välj storlekar på dina produkter först — så vet mottagaren exakt vad du önskar dig.", nameLabel:"Ditt namn", namePlaceholder:"t.ex. Frederik", copyLink:"Kopiera länk", goBack:"Gå tillbaka", copied:"Kopierad!", emptyAlert:"Din önskelista är tom — lägg till produkter först.", confirmClear:"Är du säker på att du vill tömma din önskelista?", anon:"anonym" },
    nl: { heading:"Mijn verlanglijst", sharedFrom:"Verlanglijst van ", sharedNoName:"Gedeelde verlanglijst", sharedNotice:"Je bekijkt een gedeelde verlanglijst.", clear:"Verlanglijst legen", share:"Verlanglijst delen", empty:"Je hebt nog geen opgeslagen favorieten.", add:"Toevoegen aan verlanglijst", remove:"Verwijderen uit verlanglijst", adding:"Toevoegen...", added:"Toegevoegd!", addToCart:"IN WINKELMAND", tryAgain:"Probeer opnieuw", soldOut:"Uitverkocht", chooseVariant:"Kies variant", chooseSize:"Kies maat", soldOutSuffix:" - Uitverkocht", shareTitle:"Deel je verlanglijst", shareIntro:"Vul je naam in, zodat de ontvanger weet van wie de lijst is.", shareTip:"Tip: Wil je delen met gekozen maten? Klik op Terug en kies eerst maten voor je producten — dan weet de ontvanger precies wat je wilt.", nameLabel:"Je naam", namePlaceholder:"bijv. Frederik", copyLink:"Link kopiëren", goBack:"Terug", copied:"Gekopieerd!", emptyAlert:"Je verlanglijst is leeg — voeg eerst producten toe.", confirmClear:"Weet je zeker dat je je verlanglijst wilt legen?", anon:"anoniem" },
    de: { heading:"Meine Wunschliste", sharedFrom:"Wunschliste von ", sharedNoName:"Geteilte Wunschliste", sharedNotice:"Du siehst eine geteilte Wunschliste.", clear:"Wunschliste leeren", share:"Wunschliste teilen", empty:"Du hast noch keine gespeicherten Favoriten.", add:"Zur Wunschliste hinzufügen", remove:"Von Wunschliste entfernen", adding:"Wird hinzugefügt...", added:"Hinzugefügt!", addToCart:"IN DEN WARENKORB", tryAgain:"Erneut versuchen", soldOut:"Ausverkauft", chooseVariant:"Variante wählen", chooseSize:"Größe wählen", soldOutSuffix:" - Ausverkauft", shareTitle:"Teile deine Wunschliste", shareIntro:"Gib deinen Namen ein, damit der Empfänger weiß, von wem die Liste ist.", shareTip:"Tipp: Möchtest du mit gewählten Größen teilen? Klicke auf Zurück und wähle zuerst Größen für deine Produkte — so weiß der Empfänger genau, was du dir wünschst.", nameLabel:"Dein Name", namePlaceholder:"z. B. Frederik", copyLink:"Link kopieren", goBack:"Zurück", copied:"Kopiert!", emptyAlert:"Deine Wunschliste ist leer — füge zuerst Produkte hinzu.", confirmClear:"Möchtest du deine Wunschliste wirklich leeren?", anon:"anonym" },
    en: { heading:"My wishlist", sharedFrom:"Wishlist from ", sharedNoName:"Shared wishlist", sharedNotice:"You're viewing a shared wishlist.", clear:"Clear wishlist", share:"Share wishlist", empty:"You don't have any saved favourites yet.", add:"Add to wishlist", remove:"Remove from wishlist", adding:"Adding...", added:"Added!", addToCart:"ADD TO CART", tryAgain:"Try again", soldOut:"Sold out", chooseVariant:"Choose variant", chooseSize:"Choose size", soldOutSuffix:" - Sold out", shareTitle:"Share your wishlist", shareIntro:"Enter your name so the recipient knows who the list is from.", shareTip:"Tip: Want to share with chosen sizes? Click Go back and select sizes for your products first — then the recipient knows exactly what you want.", nameLabel:"Your name", namePlaceholder:"e.g. Frederik", copyLink:"Copy link", goBack:"Go back", copied:"Copied!", emptyAlert:"Your wishlist is empty — add products first.", confirmClear:"Are you sure you want to clear your wishlist?", anon:"anonymous" },
    pl: { heading:"Moja lista życzeń", sharedFrom:"Lista życzeń od ", sharedNoName:"Udostępniona lista życzeń", sharedNotice:"Przeglądasz udostępnioną listę życzeń.", clear:"Wyczyść listę życzeń", share:"Udostępnij listę życzeń", empty:"Nie masz jeszcze zapisanych ulubionych.", add:"Dodaj do listy życzeń", remove:"Usuń z listy życzeń", adding:"Dodawanie...", added:"Dodano!", addToCart:"DODAJ DO KOSZYKA", tryAgain:"Spróbuj ponownie", soldOut:"Wyprzedane", chooseVariant:"Wybierz wariant", chooseSize:"Wybierz rozmiar", soldOutSuffix:" - Wyprzedane", shareTitle:"Udostępnij swoją listę życzeń", shareIntro:"Wpisz swoje imię, aby odbiorca wiedział, od kogo jest lista.", shareTip:"Wskazówka: Chcesz udostępnić z wybranymi rozmiarami? Kliknij Wróć i najpierw wybierz rozmiary produktów — wtedy odbiorca będzie wiedział dokładnie, czego chcesz.", nameLabel:"Twoje imię", namePlaceholder:"np. Frederik", copyLink:"Kopiuj link", goBack:"Wróć", copied:"Skopiowano!", emptyAlert:"Twoja lista życzeń jest pusta — najpierw dodaj produkty.", confirmClear:"Czy na pewno chcesz wyczyścić swoją listę życzeń?", anon:"anonimowy" },
    fr: { heading:"Ma liste de souhaits", sharedFrom:"Liste de souhaits de ", sharedNoName:"Liste de souhaits partagée", sharedNotice:"Vous consultez une liste de souhaits partagée.", clear:"Vider la liste de souhaits", share:"Partager la liste de souhaits", empty:"Vous n'avez pas encore de favoris enregistrés.", add:"Ajouter à la liste de souhaits", remove:"Retirer de la liste de souhaits", adding:"Ajout...", added:"Ajouté !", addToCart:"AJOUTER AU PANIER", tryAgain:"Réessayer", soldOut:"Épuisé", chooseVariant:"Choisir une variante", chooseSize:"Choisir la taille", soldOutSuffix:" - Épuisé", shareTitle:"Partagez votre liste de souhaits", shareIntro:"Saisissez votre nom pour que le destinataire sache de qui vient la liste.", shareTip:"Astuce : vous souhaitez partager avec les tailles choisies ? Cliquez sur Retour et sélectionnez d'abord les tailles de vos produits — le destinataire saura ainsi exactement ce que vous voulez.", nameLabel:"Votre nom", namePlaceholder:"ex. Frederik", copyLink:"Copier le lien", goBack:"Retour", copied:"Copié !", emptyAlert:"Votre liste de souhaits est vide — ajoutez d'abord des produits.", confirmClear:"Voulez-vous vraiment vider votre liste de souhaits ?", anon:"anonyme" }
  };
  TR.be = TR.nl;   // Belgien -> hollandsk (sig til hvis det skal være fransk)
  TR.at = TR.de;   // Østrig  -> tysk
  var L = TR[SHOP] || TR.en;


  function getList() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      return raw.filter(function(i) { return i && i.id && i.handle; });
    } catch(e) { return []; }
  }
  function saveList(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch(e) {}
  }
  function isLiked(id) {
    return getList().some(function(i) { return i.id === String(id); });
  }
  function toggleProduct(id, handle) {
    var list = getList();
    var idx = -1;
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === String(id)) { idx = i; break; }
    }
    if (idx !== -1) { list.splice(idx, 1); saveList(list); return false; }
    list.push({ id: String(id), handle: handle || '' });
    saveList(list);
    return true;
  }

  function updateBadge() {
    var badges = document.querySelectorAll('.tt-wishlist-count');
    if (!badges.length) return;
    var count = getList().length;
    var txt = count > 0 ? String(count) : '';
    badges.forEach(function(b) { if (b.textContent !== txt) b.textContent = txt; });
  }

  // Kurven genopbygger headerens hoejre side (main.js updateFromCartChange), og den
  // nye HTML fra Shopify har altid et tomt ønskeliste-tal. Saet tallet igen naar
  // en ny taeller dukker op.
  function watchBadge() {
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function(muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.matches('.tt-wishlist-count') || n.querySelector('.tt-wishlist-count'))) {
            updateBadge();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function syncHearts() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(function(btn) {
      var liked = isLiked(btn.dataset.wishlistBtn);
      btn.classList.toggle('tt-heart--active', liked);
      btn.setAttribute('aria-label', liked ? L.remove : L.add);
    });
    updateBadge();
  }

  function isOnWishlistPage() {
    return !!document.querySelector('[data-wishlist-grid]');
  }

  function getUrlParams() {
    var params = new URLSearchParams(window.location.search);
    var shared = params.get('shared');
    var name = params.get('name');
    if (!shared) return null;
    return {
      items: shared.split(',').filter(Boolean).map(function(entry) {
        var parts = entry.split(':');
        return { id: parts[0], handle: parts[1], variantId: parts[2] || null };
      }),
      name: name ? decodeURIComponent(name) : null
    };
  }

  function trackEvent(name, data) {
    try {
      document.dispatchEvent(new CustomEvent('shopify:' + name, { bubbles: true, detail: data || {} }));
    } catch(e) {}
    try {
      if (STAT_KEYS[name]) { fetch(STAT_API + '/hit/' + STAT_KEYS[name] + '?_=' + Date.now(), { cache: 'no-store', keepalive: true }).catch(function(){}); }
    } catch(e) {}
  }

  function copyToClipboard(text, onSuccess) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(onSuccess).catch(function() { fallbackCopy(text, onSuccess); });
    } else { fallbackCopy(text, onSuccess); }
  }
  function fallbackCopy(text, onSuccess) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0;';
    document.body.appendChild(ta); ta.focus(); ta.select();
    try { document.execCommand('copy'); onSuccess(); } catch(e) {}
    document.body.removeChild(ta);
  }

  function addToCart(variantId, productHandle, btn) {
    btn.disabled = true;
    btn.textContent = L.adding;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.textContent = L.added;
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      trackEvent('wishlist_add_to_cart', { variant_id: variantId, product_handle: productHandle });
      setTimeout(function() { btn.disabled = false; btn.textContent = L.addToCart; }, 2000);
    })
    .catch(function() { btn.disabled = false; btn.textContent = L.tryAgain; });
  }

  function buildQuickBuy(product, card, preselectedVariantId) {
    var variants = product.variants;
    var qb = document.createElement('div');
    qb.className = 'tt-quickbuy';
    var select = document.createElement('select');
    select.className = 'tt-quickbuy__select';
    select.setAttribute('aria-label', L.chooseVariant);
    if (variants.length > 1 && !preselectedVariantId) {
      var defaultOpt = document.createElement('option');
      defaultOpt.value = ''; defaultOpt.textContent = L.chooseSize;
      defaultOpt.disabled = true; defaultOpt.selected = true;
      select.appendChild(defaultOpt);
    }
    variants.forEach(function(v) {
      var opt = document.createElement('option');
      opt.value = v.id; opt.textContent = v.title;
      if (!v.available) { opt.textContent += L.soldOutSuffix; opt.disabled = true; }
      select.appendChild(opt);
    });
    if (preselectedVariantId) { select.value = preselectedVariantId; }
    else if (variants.length === 1) { select.selectedIndex = 0; }
    var btn = document.createElement('button');
    btn.className = 'tt-quickbuy__btn'; btn.type = 'button';
    if (variants.length === 1 && !variants[0].available) {
      btn.textContent = L.soldOut; btn.disabled = true;
    } else {
      btn.textContent = L.addToCart;
      btn.addEventListener('click', function() {
        var variantId = select.value;
        if (!variantId) {
          select.focus(); select.style.borderColor = '#e00';
          setTimeout(function() { select.style.borderColor = ''; }, 1500);
          return;
        }
        addToCart(variantId, product.handle, btn);
      });
    }
    qb.appendChild(select); qb.appendChild(btn); card.appendChild(qb);
  }

  // Renderer kortene i listens raekkefoelge. Produkter der ikke laengere findes i
  // shoppen (udgaaet/fjernet) giver et tomt svar uden <product-block>; de fjernes
  // fra den gemte liste, saa taelleren i headeren passer med det der vises.
  function renderCards(list, isShared) {
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!grid) return;
    grid.innerHTML = '';
    if (list.length === 0) { if (empty) empty.removeAttribute('hidden'); return; }
    if (empty) empty.setAttribute('hidden', '');
    var deadIds = [];
    var slots = list.map(function() { return null; });
    function placeCard(index, card) {
      slots[index] = card;
      var next = null;
      for (var j = index + 1; j < slots.length; j++) { if (slots[j] && slots[j].parentNode === grid) { next = slots[j]; break; } }
      grid.insertBefore(card, next);
    }
    var jobs = list.map(function(item, index) {
      var handle = item.handle, id = item.id, variantId = item.variantId || null;
      return fetch('/products/' + encodeURIComponent(handle) + '?section_id=wishlist-product-card')
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = html.trim();
          var card = wrapper.querySelector('product-block');
          if (!card) { deadIds.push(String(id)); return; }
          card.setAttribute('data-wishlist-id', id);
          var heartBtn = card.querySelector('[data-wishlist-btn]');
          if (heartBtn) { if (isShared) { heartBtn.style.display = 'none'; } else { heartBtn.classList.add('tt-heart--active'); } }
          fetch('/products/' + encodeURIComponent(handle) + '.js').then(function(r) { return r.json(); }).then(function(product) { buildQuickBuy(product, card, variantId); }).catch(function(){});
          placeCard(index, card);
        })
        .catch(function() {}); // netvaerksfejl: behold produktet i listen, vis det bare ikke nu
    });
    Promise.all(jobs).then(function() {
      if (!isShared && deadIds.length) {
        saveList(getList().filter(function(i) { return deadIds.indexOf(String(i.id)) === -1; }));
        updateBadge();
      }
      if (!grid.querySelector('product-block') && empty) empty.removeAttribute('hidden');
    });
  }

  function renderWishlistPage() {
    if (!isOnWishlistPage()) return;
    trackEvent('wishlist_visit', {});
    if (STAT_KEYS.wishlist_uvisit && GEN_KEY) {
      fetch(STAT_API + '/get/' + GEN_KEY + '?_=' + Date.now())
        .then(function (r) { return r.ok ? r.json() : { value: 0 }; })
        .then(function (d) { return (d && d.value != null) ? d.value : 0; })
        .catch(function () { return 0; })
        .then(function (gen) {
          var flag = 'tt_wl_uv_' + SHOP + '_' + gen, seen = false;
          try { seen = !!localStorage.getItem(flag); } catch (e) { seen = true; }
          if (seen) return;
          fetch(STAT_API + '/hit/' + STAT_KEYS.wishlist_uvisit + '?_=' + Date.now(), { cache: 'no-store', keepalive: true })
            .then(function (r) { if (r && r.ok) { try { localStorage.setItem(flag, '1'); } catch (e) {} try { document.dispatchEvent(new CustomEvent('shopify:wishlist_uvisit', { bubbles: true, detail: {} })); } catch (e) {} } })
            .catch(function () {});
        });
    }
    var urlData = getUrlParams();
    if (urlData) {
      renderCards(urlData.items, true);
      trackEvent('wishlist_open_shared', { by: urlData.name || L.anon });
      var actions = document.querySelector('.tt-wishlist-actions');
      if (actions) actions.style.display = 'none';
      var heading = document.querySelector('[data-wishlist-heading]');
      if (heading) { heading.textContent = urlData.name ? (L.sharedFrom + urlData.name) : L.sharedNoName; }
      var notice = document.querySelector('[data-wishlist-shared-notice]');
      if (notice) notice.removeAttribute('hidden');
      return;
    }
    renderCards(getList(), false);
  }

  function getSelectedVariants() {
    var list = getList();
    return list.map(function(item) {
      var card = document.querySelector('product-block[data-wishlist-id="' + item.id + '"]');
      var variantId = null;
      if (card) { var select = card.querySelector('.tt-quickbuy__select'); if (select && select.value) variantId = select.value; }
      return { id: item.id, handle: item.handle, variantId: variantId };
    });
  }

  function showShareModal() {
    var overlay = document.createElement('div');
    overlay.id = 'tt-share-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:9999;display:flex;align-items:center;justify-content:center;';
    var modal = document.createElement('div');
    modal.style.cssText = 'background:#fff;border-radius:8px;padding:32px;max-width:420px;width:90%;box-shadow:0 8px 32px rgba(0,0,0,0.2);';
    modal.innerHTML =
      '<h3 style="margin:0 0 8px;font-size:1.1em;font-weight:600;">' + L.shareTitle + '</h3>' +
      '<p style="margin:0 0 16px;font-size:0.85em;color:#666;">' + L.shareIntro + '</p>' +
      '<div style="margin:0 0 20px;padding:12px 14px;background:#f9f9f9;border:1px solid #eee;border-radius:6px;font-size:0.82em;color:#555;line-height:1.5;">💡 ' + L.shareTip + '</div>' +
      '<label style="display:block;font-size:0.85em;font-weight:500;margin-bottom:6px;">' + L.nameLabel + '</label>' +
      '<input id="tt-share-name" type="text" placeholder="' + L.namePlaceholder + '" style="width:100%;padding:10px 12px;border:1px solid #ccc;border-radius:4px;font-size:0.95em;box-sizing:border-box;margin-bottom:16px;">' +
      '<div style="display:flex;gap:10px;">' +
        '<button id="tt-share-copy-btn" type="button" style="flex:1;padding:10px;background:#000;color:#fff;border:none;border-radius:4px;font-size:0.9em;font-weight:600;cursor:pointer;">' + L.copyLink + '</button>' +
        '<button id="tt-share-back-btn" type="button" style="padding:10px 16px;background:#fff;color:#333;border:1px solid #ccc;border-radius:4px;font-size:0.9em;cursor:pointer;">' + L.goBack + '</button>' +
      '</div>';
    overlay.appendChild(modal); document.body.appendChild(overlay);
    var nameInput = document.getElementById('tt-share-name'); nameInput.focus();
    function closeModal() { if (document.body.contains(overlay)) document.body.removeChild(overlay); }
    document.getElementById('tt-share-back-btn').addEventListener('click', closeModal);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) closeModal(); });
    function doShare() {
      var name = nameInput.value.trim();
      var variants = getSelectedVariants();
      var ids = variants.map(function(i) { return i.id + ':' + i.handle + (i.variantId ? ':' + i.variantId : ''); }).join(',');
      var url = window.location.origin + window.location.pathname + '?shared=' + ids + (name ? '&name=' + encodeURIComponent(name) : '') + '&utm_source=wishlist&utm_medium=share&utm_campaign=onskeliste';
      var copyBtn = document.getElementById('tt-share-copy-btn');
      copyToClipboard(url, function() {
        trackEvent('wishlist_share', { item_count: variants.length, shared_by: name || L.anon });
        copyBtn.textContent = L.copied;
        setTimeout(closeModal, 1200);
      });
    }
    document.getElementById('tt-share-copy-btn').addEventListener('click', doShare);
    nameInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') doShare(); });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var id = btn.dataset.wishlistBtn;
    var handle = btn.dataset.wishlistHandle || '';
    var liked = toggleProduct(id, handle);
    btn.classList.toggle('tt-heart--active', liked);
    btn.setAttribute('aria-label', liked ? L.remove : L.add);
    btn.classList.add('tt-heart--pop');
    setTimeout(function() { btn.classList.remove('tt-heart--pop'); }, 350);
    updateBadge();
    if (liked) {
      trackEvent('wishlist_like', { product_id: id, product_handle: handle });
      bumpTopProduct(handle);
    }
    if (isOnWishlistPage() && !liked && !getUrlParams()) {
      var card = document.querySelector('product-block[data-wishlist-id="' + id + '"]');
      if (card) card.remove();
      if (getList().length === 0) { var empty = document.querySelector('[data-wishlist-empty]'); if (empty) empty.removeAttribute('hidden'); }
    }
  });

  function applyStatic() {
    var head = document.querySelector('[data-wishlist-heading]');
    if (head && !getUrlParams()) head.textContent = L.heading;
    var clr = document.querySelector('#tt-clear-wishlist .tt-btn-label'); if (clr) clr.textContent = L.clear;
    var shr = document.querySelector('#tt-share-wishlist .tt-btn-label'); if (shr) shr.textContent = L.share;
    var emp = document.querySelector('[data-wishlist-empty]'); if (emp) emp.textContent = L.empty;
    var notice = document.querySelector('[data-wishlist-shared-notice]'); if (notice) notice.textContent = L.sharedNotice;
  }

  function initActions() {
    var clearBtn = document.getElementById('tt-clear-wishlist');
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        if (confirm(L.confirmClear)) { saveList([]); updateBadge(); syncHearts(); window.location.reload(); }
      });
    }
    var shareBtn = document.getElementById('tt-share-wishlist');
    if (shareBtn) {
      shareBtn.addEventListener('click', function() {
        if (getList().length === 0) { alert(L.emptyAlert); return; }
        showShareModal();
      });
    }
  }

  function init() { applyStatic(); syncHearts(); renderWishlistPage(); initActions(); watchBadge(); }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
